"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addressSchema = void 0;
var _zod = require("zod");
var addressSchema = t => {
  return _zod.z.object({
    addressLine1: _zod.z.string().min(1, t('users.userMgmt.employee.edit.error.addressLine1.required')),
    addressLine2: _zod.z.string(),
    addressLine3: _zod.z.string(),
    addressLine4: _zod.z.string(),
    addressLine5: _zod.z.string(),
    postCode: _zod.z.string().min(1, t('users.userMgmt.employee.add.companyAddress.error.invalidPostcode')),
    country: _zod.z.string()
  });
};
exports.addressSchema = addressSchema;